// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"125":"ec9c05ee8b4ed47d05f8","279":"3193454d73f03562a7e5"}[chunkId] + ".js";
};